// ClientLocalizationProvider.tsx
'use client';

import React from 'react';
import {store} from '../../app/store/index'
import { Provider } from 'react-redux';

interface ClientLocalizationProviderProps {
  children: React.ReactNode;
}

export default function ReactReduxProvider({
  children,
}: ClientLocalizationProviderProps) {
  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
}
